import IconPDF from './component.jsx'
export default IconPDF
